import React from "react";
import styled from "styled-components";
import * as Icons from "@loadsmart/icons";

import Usage from "./Usage";

const PageWrapper = styled.div`
  max-width: 860px;
  margin: 100px auto;
  padding: 0 30px;
`;

const IconsWrapper = styled.div`
  margin: 20px 0;
  max-width: 100vw;
  overflow: hidden;
`;

const Title = styled.h2`
  margin-top: 20px;
`;

const Icon = styled.div`
  color: #444;
  border-radius: 5px;
  font-size: 150%;
  text-align: center;
`;

const IconButton = styled.a`
  border: #ddd 1px solid;
  border-radius: 4px;
  display: block;
  padding: 25px 0;
  width: 100%;
`;

const IconTitle = styled.span`
  background: #fefefe;
  display: block;
  font-size: 10px;
  font-weight: 600;
  overflow-x: auto;
  margin-top: 10px;
  padding: 5px;
  width: 100%;
  text-align: center;
`;

const IconsSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  background-color: #fff;
  color: #444;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
  }

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 15px;
  }
`;

const mapIcons = () => {
  const iconMap = {};

  Object.keys(Icons).forEach((key, index) => {
    const splitName = key.replace(/([a-z])([A-Z])/g, "$1 $2").split(" ");
    const mapKey =
      splitName.length === 2 ||
      splitName[1] === "Caret" ||
      splitName[1] === "Check" ||
      splitName[1] === "Info" ||
      splitName[1] === "Eye" ||
      splitName[1] === "Question" ||
      splitName[1] === "Misc"
        ? "General"
        : splitName[1];

    const Component = Icons[key];

    if (!iconMap[mapKey]) iconMap[mapKey] = [];
    iconMap[mapKey] = [
      ...iconMap[mapKey],
      <Icon key={index}>
        <IconButton>
          <Component width={42} height={42} />
        </IconButton>
        <IconTitle>{key}</IconTitle>
      </Icon>,
    ];
  });

  return iconMap;
};

const List = () => {
  const mappedIcons = mapIcons();

  return (
    <PageWrapper>
      <Usage />
      <Title>Available Icons</Title>
      <IconsWrapper>
        {Object.keys(mappedIcons).map((key, index) => {
          return (
            <>
              <h3>{key}</h3>
              <IconsSection key={index}>{mappedIcons[key]}</IconsSection>
            </>
          );
        })}
      </IconsWrapper>
    </PageWrapper>
  );
};

export default List;
